import config from "../config/config"
import AIChatHelper from './AIChatHelper'
import AuthenticationHelper from './AuthenticationHelper'

class ChatSocketHelper{

    static ChatSocketObj=null
    static AIMessageHandler = null // optional handler to mimic socket onmessage for AI flows

    logout()
    {
        if(ChatSocketHelper.ChatSocketObj !== null)
        {
            ChatSocketHelper.ChatSocketObj.close()
        }
        return ChatSocketHelper.ChatSocketObj = null
    }

    connectToSocket(webSocketUrl,chatToken,passwordDict){
        return new Promise( (resolve, reject) => {
            const server = new WebSocket(webSocketUrl);
            server.onopen = () => {

                //try sending the connect message
                this.sendConnectionMessage(server)

                //try logging in with username and token after establishing connection
                if(chatToken)
                    this.loginWithToken(server,chatToken)
                else if(passwordDict.username && passwordDict.password)
                    this.loginWithPassword(server,passwordDict.username, passwordDict.password)

                resolve(server);
            };
            server.onerror = (err) => {
                console.log('chat socket connection error:'+ err)
                reject(err);
            };
    
        });
    }

    async connectToChatWithPassword(passwordDict,handleUpdateMessage){

        if (ChatSocketHelper.ChatSocketObj)
        {
            //console.log("chat socket object already exists")
            //subscribe to the event handlers also
            ChatSocketHelper.ChatSocketObj.onmessage = (event) => this.messageHandler(event,handleUpdateMessage)
            ChatSocketHelper.ChatSocketObj.onclose = () => this.onCloseHandler()

            return true
        }

        //create a new socket connection if it does not exist
        try
        {
            ChatSocketHelper.ChatSocketObj = await this.connectToSocket(config.chatServer.url,null,passwordDict)
        }
        catch(error)
        {
            return error
        }

        //log all the event handlers
        ChatSocketHelper.ChatSocketObj.onmessage = (event) => this.messageHandler(event,handleUpdateMessage)
        ChatSocketHelper.ChatSocketObj.onclose = () => this.onCloseHandler()

        //connected successfully, return true
        return true

    }

    async connectToChatWithToken(chatToken,handleUpdateMessage){

        if (ChatSocketHelper.ChatSocketObj)
        {
            //console.log("chat socket object already exists")
            //subscribe to the event handlers also
            ChatSocketHelper.ChatSocketObj.onmessage = (event) => this.messageHandler(event,handleUpdateMessage)
            ChatSocketHelper.ChatSocketObj.onclose = () => this.onCloseHandler()

            return true
        }

        //create a new socket connection if it does not exist
        try
        {
            ChatSocketHelper.ChatSocketObj = await this.connectToSocket(config.chatServer.url,chatToken,null)
        }
        catch(error)
        {
            return error
        }

        //log all the event handlers
        ChatSocketHelper.ChatSocketObj.onmessage = (event) => this.messageHandler(event,handleUpdateMessage)
        ChatSocketHelper.ChatSocketObj.onclose = () => this.onCloseHandler()

        //connected successfully, return true
        return true

    }

    // Lightweight "connection" for AI chat: register a handler to receive normalized message events
    connectToAI(handleUpdateMessage){
        ChatSocketHelper.AIMessageHandler = typeof handleUpdateMessage === 'function' ? handleUpdateMessage : null
        try{
            // open SSE stream to receive server-pushed AI messages (provide token in query string)
            const token = (typeof AuthenticationHelper !== 'undefined' && AuthenticationHelper.token) ? AuthenticationHelper.token : null
            if(!token) return true
            const url = `${config.localAuth.apiServiceUrl}aichat?stream=1&token=${encodeURIComponent(token)}`
            if(ChatSocketHelper._aiEventSource){
                ChatSocketHelper._aiEventSource.close()
            }
            ChatSocketHelper._aiEventSource = new EventSource(url)
            ChatSocketHelper._aiEventSource.onmessage = (evt) => {
                try{
                    const parsed = JSON.parse(evt.data)
                    // Expect payload: { type: 'ai_message', conversation_id, assistant }
                    if(parsed && parsed.type === 'ai_message'){
                        const convId = parsed.conversation_id || (`ai-${AuthenticationHelper.uuid}`)
                        const nowIso = new Date().toISOString()
                        const makeId = () => ChatSocketHelper.create_UUID()
                        const emitted = [{ _id: makeId(), rid: convId, msg: parsed.assistant && parsed.assistant.content ? parsed.assistant.content : '', u: { username: 'ai' }, ts: { $date: nowIso } }]
                        if(ChatSocketHelper.AIMessageHandler) ChatSocketHelper.AIMessageHandler(emitted)
                    }
                }catch(e){
                    // ignore non-json keep-alives
                }
            }
            ChatSocketHelper._aiEventSource.onerror = (err) => {
                // if connection fails, close and cleanup
                try{ ChatSocketHelper._aiEventSource.close() }catch(e){}
                ChatSocketHelper._aiEventSource = null
            }
        }catch(e){
            // EventSource unsupported or failed — silently ignore, fallback to polling
        }
        return true
    }


    /************************************* */
    /*   CHAT HANDLERS                     */
    /***************************************/

    messageHandler(event,handleUpdateMessage){
        // on receiving a message, add it to the list of messages
        let response = JSON.parse(event.data);
        //console.log('response', response);

        //if the system sends a ping, respond back
        if (response.msg == 'ping') {
            //console.log('pong!');
            ChatSocketHelper.ChatSocketObj.send(JSON.stringify({msg: 'pong'}))
        }

        if (response.msg== 'result' && response.id=='history-request')
        {
            if(response.error)
            {
                console.log(response.error.error)
            }
            else
            {
                handleUpdateMessage(response.result.messages)
            }
        }

        // if the other user has sent the message
        if (response.msg === 'changed' && response.collection === 'stream-room-messages') {
            if(response.error)
            {
                console.log(response.error.error)
            }
            else
            {
                handleUpdateMessage(response.fields.args)
            }
        }
    }

    sortMessageByDates(msgArr = [])
    {
        let newMsgArr = msgArr.sort(function(a,b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            // console.log(new Date(b.ts.$date) - new Date(a.ts.$date))
            return new Date(a.ts.$date) - new Date(b.ts.$date)
        })
        return newMsgArr
    }


    onCloseHandler(){
        console.log('disconnected by server')
    }

    /************************************* */
    /*   VARIOUS CONNECT METHODS           */
    /***************************************/

    //send connection message
    sendConnectionMessage(socket){
        const connectRequest = {
            "msg": "connect",
            "version": "1",
            "support": ["1"]
        }
        //console.log("Send connect request")
        socket.send(JSON.stringify(connectRequest));
    }

    //login using token
    loginWithToken(server,chatToken){
        const loginRequest = {
            "msg": "method",
            "method": "login",
            "id": "try-login",
            "params": [
                { "resume": chatToken}
              ]
        }
        
        server.send(JSON.stringify(loginRequest));
    }
  
    loginWithPassword(server,username,password){
        const loginRequest = {
            "msg": "method",
            "method": "login",
            "id": "try-login",
            "params": [
                {
                "user":{"username":username},
                "password":password
                }
              ]
        }
        //console.log("Logging in with password")
        server.send(JSON.stringify(loginRequest));        
    }

    //subscribe to room and stream the messages
    subscribeToOneRoomMessages(roomId){
        const subscribeRequest = {
            "msg": "sub",
            "id": "sub-room-"+roomId,
            "name": "stream-room-messages",
            "params":[
                roomId,
                false
            ]
        }
        //console.log("Sending sub to room messages for:"+roomId)
        ChatSocketHelper.ChatSocketObj.send(JSON.stringify(subscribeRequest));
    }

    // Fetch AI conversation history and emit via AI message handler
    async getMessagesFromAIConversation(conversationId){
        if(!conversationId) return null
        try{
            const resp = await AIChatHelper.getConversation(conversationId)
            if(resp && Array.isArray(resp.messages) && ChatSocketHelper.AIMessageHandler){
                const normalized = resp.messages.map(m => ({
                    _id: m.id || m._id || this.create_UUID(),
                    rid: conversationId,
                    msg: m.content || m.message || '',
                    u: { username: m.role === 'assistant' ? 'ai' : (AuthenticationHelper.uuid || 'me') },
                    ts: { $date: m.create_time || m.createTime || new Date().toISOString() }
                }))
                ChatSocketHelper.AIMessageHandler(normalized)
            }
            return true
        }catch(e){
            console.log('AI history load failed', e)
            return false
        }
    }

    //get all the messages from the room
    getMessagesFromOneRoom(roomId){
        const getHistoryRequest = {
            "msg": "method",
            "method": "loadHistory",
            "id": "history-request",
            "params":[
                roomId,
                null,
                50
            ]
        }
        //console.log("Getting history of messages for:"+roomId)
        ChatSocketHelper.ChatSocketObj.send(JSON.stringify(getHistoryRequest));
    } 


    //call to subscribe to a list of rooms
    subscribeToRooms(roomIdList){
        roomIdList.forEach( (eachRoomId) => {
            this.subscribeToOneRoomMessages(eachRoomId.roomId)
            this.getMessagesFromOneRoom(eachRoomId.roomId)
            }
        )
    }
    

    sendMessageToRoom(roomId,msg,username){
        const request={
            "msg": "method",
            "method": "sendMessage",
            "id": "send-message-"+username+"-room-"+roomId,
            "params": 
            [
               {
                 "_id": this.create_UUID(),
                 "rid": roomId,
                 "msg": msg
               }
            ]
         }
         //console.log("Sending Message To room:"+roomId)
         ChatSocketHelper.ChatSocketObj.send(JSON.stringify(request));
    }

    // Send a message to AI endpoint and emit user+assistant messages via AI handler
    async sendMessageToAI({ botId, rid, msg, systemMessage = null, model = null }){
        try{
            const userMsg = { role: 'user', content: msg }
            const body = { messages: [userMsg] }
            if(botId) body.bot_id = botId
            if(model) body.model = model
            if(rid) body.room_id = rid
            if(systemMessage) body.system_message = systemMessage
            const res = await AIChatHelper.sendMessage(body)
            const conversationId = res && (res.conversation_id || res.conversationId || res.conversation)
            const assistantContent = res && res.assistant && res.assistant.content ? res.assistant.content : ''
            const nowIso = new Date().toISOString()
            const makeId = () => this.create_UUID()
            const emitted = []
            const ridToUse = conversationId || rid || `ai-${botId || 'room'}`
            // emit user message first
            emitted.push({ _id: makeId(), rid: ridToUse, msg: msg, u: { username: AuthenticationHelper.uuid || 'me' }, ts: { $date: nowIso } })
            if(assistantContent){
                emitted.push({ _id: makeId(), rid: ridToUse, msg: assistantContent, u: { username: botId || 'ai' }, ts: { $date: nowIso } })
            }
            if(ChatSocketHelper.AIMessageHandler){
                ChatSocketHelper.AIMessageHandler(emitted)
            }
            return { ok: true, conversationId, messages: emitted }
        }catch(e){
            console.log('AI send failed', e)
            return { ok: false, error: e?.message || String(e) }
        }
    }

    /**************************/
    /*  Useful functions      */
    /**************************/
    create_UUID(){
        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (dt + Math.random()*16)%16 | 0;
            dt = Math.floor(dt/16);
            return (c=='x' ? r :(r&0x3|0x8)).toString(16);
        });
        return uuid;
    }


}

export default new ChatSocketHelper()